import * as React from "react";
import { forwardRef } from "react";
const SvgIconAddLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11 21.5V13.5H3V11.5H11V3.5H13V11.5H21V13.5H13V21.5H11Z", fill: "#A4A4A4" }));
const ForwardRef = forwardRef(SvgIconAddLeft);
export default ForwardRef;
